export default __webpack_public_path__ + "static/media/ExtensionHandle.179e680f.glb";